import React from 'react';

export const VWeirImage = () => {
  return (
    <svg width="516" height="278" viewBox="0 0 516 278" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="516" height="278" fill="white" />
      <mask
        id="mask0_3346_198656"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="265"
        y="133"
        width="224"
        height="106"
      >
        <rect x="265.268" y="133.986" width="222.847" height="104.339" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3346_198656)">
        <g filter="url(#filter0_i_3346_198656)">
          <path
            d="M272.996 188.085H649.13C649.13 186.692 649.131 145.466 649.13 143.279C497.008 148.579 482.317 143.279 388.284 143.279C335.751 143.279 272.996 143.279 272.996 143.279C272.996 143.279 272.996 187.231 272.996 188.085Z"
            fill="url(#paint0_linear_3346_198656)"
          />
        </g>
        <path
          d="M266.736 138.366C266.736 136.758 268.039 135.455 269.647 135.455H320.829C321.58 135.455 322.302 135.745 322.844 136.264L372.966 184.311C375.228 186.479 378.798 186.479 381.06 184.311L431.182 136.264C431.724 135.745 432.446 135.455 433.196 135.455H483.734C485.342 135.455 486.646 136.758 486.646 138.366V233.945C486.646 235.553 485.342 236.856 483.734 236.856H269.647C268.039 236.856 266.736 235.553 266.736 233.945V138.366Z"
          fill="#E4E4EB"
          stroke="#F2F2F5"
          stroke-width="2.93694"
        />
      </g>
      <path
        d="M315.222 172.881L315.222 186.493"
        stroke="#72748E"
        stroke-width="1.45841"
        stroke-linecap="round"
        stroke-dasharray="2.92 4.86"
      />
      <path
        d="M315.222 135.828L315.222 149.44"
        stroke="#72748E"
        stroke-width="1.45841"
        stroke-linecap="round"
        stroke-dasharray="2.92 4.86"
      />
      <path
        d="M315.38 157.678C315.968 157.678 316.49 157.804 316.948 158.056C317.414 158.308 317.778 158.681 318.04 159.176C318.31 159.67 318.446 160.268 318.446 160.968V165.518H316.864V161.206C316.864 160.515 316.691 159.988 316.346 159.624C316 159.25 315.529 159.064 314.932 159.064C314.334 159.064 313.858 159.25 313.504 159.624C313.158 159.988 312.986 160.515 312.986 161.206V165.518H311.39V155.158H312.986V158.7C313.256 158.373 313.597 158.121 314.008 157.944C314.428 157.766 314.885 157.678 315.38 157.678Z"
        fill="#555770"
      />
      <path
        d="M315.757 139.183L319.763 135.178C320.24 134.701 319.902 133.885 319.227 133.885H311.217C310.542 133.885 310.204 134.701 310.681 135.178L314.686 139.183C314.982 139.479 315.462 139.479 315.757 139.183Z"
        fill="#72748E"
      />
      <path
        d="M315.757 183.032L319.763 187.037C320.24 187.514 319.902 188.33 319.227 188.33H311.217C310.542 188.33 310.204 187.514 310.681 187.037L314.686 183.032C314.982 182.736 315.462 182.736 315.757 183.032Z"
        fill="#72748E"
      />
      <path
        d="M431.691 140.793L431.691 187.462"
        stroke="#72748E"
        stroke-width="1.45841"
        stroke-linecap="round"
        stroke-dasharray="2.92 4.86"
      />
      <path
        d="M431.691 63.0117L431.691 109.681"
        stroke="#72748E"
        stroke-width="1.45841"
        stroke-linecap="round"
        stroke-dasharray="2.92 4.86"
      />
      <path
        d="M435.209 119.813V129.543H433.613V125.287H429.035V129.543H427.439V119.813H429.035V123.985H433.613V119.813H435.209Z"
        fill="#555770"
      />
      <path
        d="M432.227 67.3391L436.232 63.3339C436.709 62.8568 436.371 62.041 435.696 62.041H427.686C427.011 62.041 426.673 62.8568 427.15 63.3339L431.156 67.3391C431.451 67.6349 431.931 67.6349 432.227 67.3391Z"
        fill="#72748E"
      />
      <path
        d="M432.227 183.135L436.232 187.141C436.709 187.618 436.371 188.434 435.696 188.434H427.686C427.011 188.434 426.673 187.618 427.15 187.141L431.156 183.135C431.451 182.84 431.931 182.84 432.227 183.135Z"
        fill="#72748E"
      />
      <path
        d="M414.158 54.6758L411.918 50.7838H410.7V54.6758H409.104V44.9458H412.464C413.211 44.9458 413.841 45.0764 414.354 45.3378C414.877 45.5991 415.264 45.9491 415.516 46.3878C415.778 46.8264 415.908 47.3164 415.908 47.8578C415.908 48.4924 415.722 49.0711 415.348 49.5938C414.984 50.1071 414.42 50.4571 413.654 50.6438L416.062 54.6758H414.158ZM410.7 49.5098H412.464C413.062 49.5098 413.51 49.3604 413.808 49.0618C414.116 48.7631 414.27 48.3618 414.27 47.8578C414.27 47.3538 414.121 46.9618 413.822 46.6818C413.524 46.3924 413.071 46.2478 412.464 46.2478H410.7V49.5098ZM423.816 52.6878H419.742L419.042 54.6758H417.376L420.862 44.9318H422.71L426.196 54.6758H424.516L423.816 52.6878ZM423.368 51.3858L421.786 46.8638L420.19 51.3858H423.368ZM430.89 44.9458C431.926 44.9458 432.831 45.1464 433.606 45.5478C434.39 45.9398 434.992 46.5091 435.412 47.2558C435.841 47.9931 436.056 48.8564 436.056 49.8458C436.056 50.8351 435.841 51.6938 435.412 52.4218C434.992 53.1498 434.39 53.7098 433.606 54.1018C432.831 54.4844 431.926 54.6758 430.89 54.6758H427.712V44.9458H430.89ZM430.89 53.3738C432.028 53.3738 432.901 53.0658 433.508 52.4498C434.114 51.8338 434.418 50.9658 434.418 49.8458C434.418 48.7164 434.114 47.8344 433.508 47.1998C432.901 46.5651 432.028 46.2478 430.89 46.2478H429.308V53.3738H430.89ZM443.503 52.6878H439.429L438.729 54.6758H437.063L440.549 44.9318H442.397L445.883 54.6758H444.203L443.503 52.6878ZM443.055 51.3858L441.473 46.8638L439.877 51.3858H443.055ZM452.453 54.6758L450.213 50.7838H448.995V54.6758H447.399V44.9458H450.759C451.506 44.9458 452.136 45.0764 452.649 45.3378C453.172 45.5991 453.559 45.9491 453.811 46.3878C454.072 46.8264 454.203 47.3164 454.203 47.8578C454.203 48.4924 454.016 49.0711 453.643 49.5938C453.279 50.1071 452.714 50.4571 451.949 50.6438L454.357 54.6758H452.453ZM448.995 49.5098H450.759C451.356 49.5098 451.804 49.3604 452.103 49.0618C452.411 48.7631 452.565 48.3618 452.565 47.8578C452.565 47.3538 452.416 46.9618 452.117 46.6818C451.818 46.3924 451.366 46.2478 450.759 46.2478H448.995V49.5098Z"
        fill="#555770"
      />
      <path
        d="M376.582 156.033C375.817 156.033 375.182 155.818 374.678 155.389C374.183 154.95 373.815 154.329 373.572 153.527C373.329 152.715 373.208 151.744 373.208 150.615C373.208 149.476 373.32 148.501 373.544 147.689C373.768 146.877 374.127 146.256 374.622 145.827C375.126 145.397 375.779 145.183 376.582 145.183C377.357 145.183 377.996 145.397 378.5 145.827C379.004 146.247 379.377 146.863 379.62 147.675C379.872 148.487 379.998 149.467 379.998 150.615C379.998 151.744 379.881 152.715 379.648 153.527C379.424 154.329 379.06 154.95 378.556 155.389C378.061 155.818 377.403 156.033 376.582 156.033ZM376.582 155.011C377.067 155.011 377.464 154.871 377.772 154.591C378.089 154.311 378.327 153.872 378.486 153.275C378.645 152.677 378.733 151.898 378.752 150.937H374.454C374.473 151.889 374.552 152.663 374.692 153.261C374.841 153.858 375.07 154.301 375.378 154.591C375.686 154.871 376.087 155.011 376.582 155.011ZM374.454 149.985H378.738C378.71 149.135 378.617 148.435 378.458 147.885C378.299 147.325 378.066 146.909 377.758 146.639C377.45 146.359 377.058 146.219 376.582 146.219C376.106 146.219 375.714 146.359 375.406 146.639C375.107 146.909 374.883 147.325 374.734 147.885C374.585 148.435 374.491 149.135 374.454 149.985Z"
        fill="#555770"
      />
      <path
        d="M361.996 166.052L362.179 171.714C362.201 172.388 361.397 172.752 360.904 172.291L355.06 166.813C354.567 166.351 354.879 165.525 355.553 165.503L361.214 165.32C361.632 165.306 361.982 165.634 361.996 166.052Z"
        fill="#72748E"
      />
      <path
        d="M391.308 166.255L391.125 171.917C391.103 172.591 391.907 172.955 392.399 172.494L398.244 167.016C398.736 166.555 398.425 165.728 397.751 165.706L392.09 165.523C391.671 165.509 391.322 165.837 391.308 166.255Z"
        fill="#72748E"
      />
      <path
        d="M394.71 168.537C390.126 163.569 383.559 160.457 376.266 160.457C369.182 160.457 363.391 163.392 358.829 168.112"
        stroke="#72748E"
        stroke-width="1.45841"
        stroke-linecap="round"
        stroke-dasharray="2.92 4.86"
      />
      <mask
        id="mask1_3346_198656"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="35"
        y="17"
        width="186"
        height="160"
      >
        <rect x="35.999" y="17" width="184.195" height="159.187" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_3346_198656)">
        <rect
          x="0.6441"
          y="1.11561"
          width="111.379"
          height="51.3574"
          transform="matrix(0.866025 0.5 -2.20305e-08 1 122.535 16.6779)"
          fill="#E4E4EB"
          stroke="#F2F2F5"
          stroke-width="1.48749"
        />
        <g filter="url(#filter1_i_3346_198656)">
          <path
            d="M150.33 157.756L23.8197 84.7149C26.8942 82.9399 117.84 30.432 122.665 27.6466C122.665 27.6466 178.771 60.0396 210.399 78.2998C228.068 88.5012 249.175 100.687 249.175 100.687C249.175 100.687 152.216 156.667 150.33 157.756Z"
            fill="url(#paint1_radial_3346_198656)"
          />
        </g>
        <g filter="url(#filter2_i_3346_198656)">
          <path
            d="M150.33 157.756L23.8197 84.7149C26.8942 82.9399 117.84 30.432 122.665 27.6466C122.665 27.6466 178.771 60.0396 210.399 78.2998C228.068 88.5012 249.175 100.687 249.175 100.687C249.175 100.687 152.216 156.667 150.33 157.756Z"
            fill="url(#paint2_radial_3346_198656)"
          />
        </g>
        <mask id="path-23-inside-1_3346_198656" fill="white">
          <path d="M36 66.9082L133.745 123.341L133.745 176.186L36 119.753L36 66.9082Z" />
        </mask>
        <path d="M36 66.9082L133.745 123.341L133.745 176.186L36 119.753L36 66.9082Z" fill="#E4E4EB" />
        <path
          d="M36 66.9082L36 65.4207L34.7118 64.677L34.7118 66.1645L36 66.9082ZM36 119.753L34.7118 119.009L34.7118 120.497L36 121.241L36 119.753ZM36 68.3957L133.745 124.829L133.745 121.854L36 65.4207L36 68.3957ZM133.745 174.699L36 118.266L36 121.241L133.745 177.674L133.745 174.699ZM37.2882 120.497L37.2882 67.6519L34.7118 66.1645L34.7118 119.009L37.2882 120.497Z"
          fill="#F2F2F5"
          mask="url(#path-23-inside-1_3346_198656)"
        />
        <path
          d="M177.566 124.969L198.486 86.7072L219.546 74.5484L219.546 125.906L134.389 175.071L134.389 123.714L155.699 111.411L176.619 125.515L177.092 125.834L177.566 124.969Z"
          fill="#F9F9FA"
          stroke="#F2F2F5"
          stroke-width="1.48749"
        />
      </g>
      <path
        d="M177.566 124.969L198.486 86.7072L219.546 74.5484L219.546 125.906L134.389 175.071L134.389 123.714L155.699 111.411L176.619 125.515L177.092 125.834L177.566 124.969Z"
        fill="#E4E4EB"
        stroke="#F2F2F5"
        stroke-width="1.48749"
      />
      <g filter="url(#filter3_i_3346_198656)">
        <path
          d="M238.938 150.021L220.912 160.323C204.206 146.624 178.101 126.073 162.627 114.965L155.989 110.463L133.834 123.541L45.3392 72.2128C48.4137 70.4378 117.84 30.4301 122.665 27.6446C122.665 27.6446 179.44 60.4095 211.067 78.6696L198.207 86.1378L193.663 94.3654C201.779 101.727 204.883 109.438 211.067 117.157C219.419 127.58 232.072 132.622 238.938 150.021Z"
          fill="url(#paint3_radial_3346_198656)"
        />
      </g>
      <path
        d="M216.271 141.777L194.95 140.338L162.627 114.965L155.989 110.463L133.834 123.541L45.3392 72.2128C48.4137 70.4378 117.84 30.4301 122.665 27.6446C122.665 27.6446 179.44 60.4095 211.067 78.6696L198.207 86.1378L193.663 94.3654C206.502 112.419 222.154 140.338 216.271 141.777Z"
        fill="url(#paint4_linear_3346_198656)"
      />
      <path
        d="M239.054 149.885L221.1 160.841C216.313 156.676 213.838 152.492 209.485 147.646C201.539 138.8 192.026 131.118 183.208 124.16L164.411 105.833L134.3 124.16L66.2375 85.0024C69.312 83.2273 134.735 42.3983 139.559 39.6128C139.559 39.6128 180.599 62.4406 212.226 80.7008L198.469 85.8903L193.889 94.3783C198.885 101.56 205.631 107.553 211.867 118.28C216.033 123.144 223.03 127.982 227.27 132.694C237.123 141.674 236.144 144.382 239.054 149.885Z"
        fill="url(#paint5_linear_3346_198656)"
        fill-opacity="0.7"
      />
      <path
        d="M223.639 129.415C222.619 128.765 221.774 128.34 219.46 125.639L223.639 129.415C224.456 129.936 225.385 130.602 227.27 132.697L223.639 129.415Z"
        fill="url(#paint6_linear_3346_198656)"
        fill-opacity="0.7"
      />
      <path
        d="M50.3885 162.94L49.1518 162.226L45.9458 167.779L44.5515 166.974L47.7575 161.421L46.9694 160.966L47.6204 159.838L48.4085 160.293L48.6815 159.82C49.1248 159.052 49.6489 158.611 50.2537 158.497C50.8713 158.379 51.6165 158.573 52.4895 159.077L51.8245 160.228C51.4042 159.986 51.0625 159.896 50.7994 159.96C50.541 160.015 50.2998 160.237 50.0758 160.625L49.8028 161.098L51.0395 161.812L50.3885 162.94ZM54.9696 161.026L49.7896 169.998L48.4074 169.2L53.5874 160.228L54.9696 161.026ZM54.439 172.828C53.8085 172.464 53.3203 171.993 52.9744 171.416C52.6332 170.831 52.4664 170.196 52.4741 169.511C52.4865 168.817 52.691 168.127 53.0877 167.44C53.4797 166.761 53.9769 166.245 54.5793 165.893C55.1817 165.54 55.8232 165.371 56.5038 165.387C57.1845 165.403 57.844 165.595 58.4826 165.964C59.1211 166.332 59.6174 166.808 59.9714 167.389C60.3254 167.971 60.5002 168.611 60.4959 169.309C60.4917 170.007 60.2935 170.695 59.9015 171.374C59.5095 172.053 59.0083 172.567 58.3978 172.915C57.7873 173.263 57.1314 173.428 56.4299 173.411C55.7412 173.391 55.0775 173.196 54.439 172.828ZM55.132 171.627C55.4876 171.833 55.868 171.939 56.2732 171.947C56.6864 171.959 57.088 171.851 57.478 171.624C57.868 171.396 58.203 171.04 58.483 170.555C58.763 170.07 58.9057 169.608 58.9111 169.17C58.9212 168.723 58.8217 168.326 58.6125 167.979C58.4034 167.632 58.121 167.355 57.7653 167.15C57.4097 166.945 57.0293 166.838 56.6242 166.831C56.2271 166.828 55.8416 166.945 55.4678 167.182C55.0987 167.41 54.7741 167.767 54.4941 168.252C54.0787 168.972 53.9386 169.634 54.0737 170.24C54.2215 170.843 54.5743 171.305 55.132 171.627ZM72.1649 174.009L66.2347 179.492L64.7797 178.652L66.2829 172.941L62.0881 177.098L60.6332 176.258L62.4048 168.374L63.8112 169.186L62.1045 175.362L66.6241 170.81L68.0669 171.643L66.3378 177.774L70.807 173.225L72.1649 174.009ZM73.9756 179.467C74.363 178.797 74.8434 178.282 75.4169 177.923C75.9984 177.569 76.6093 177.388 77.2495 177.381C77.9025 177.37 78.524 177.535 79.1141 177.875C79.5506 178.127 79.923 178.472 80.2313 178.908C80.5523 179.342 80.7471 179.788 80.8157 180.248L82.6777 177.023L84.072 177.828L78.892 186.8L77.4977 185.995L78.0787 184.989C77.6657 185.181 77.1965 185.266 76.671 185.243C76.1536 185.224 75.6363 185.066 75.119 184.767C74.537 184.431 74.0875 183.978 73.7705 183.407C73.4663 182.832 73.3244 182.201 73.3449 181.512C73.378 180.82 73.5883 180.138 73.9756 179.467ZM79.4297 182.649C79.6957 182.188 79.8297 181.732 79.8317 181.28C79.8418 180.834 79.7446 180.433 79.5401 180.077C79.3357 179.722 79.0556 179.442 78.6999 179.237C78.3443 179.031 77.9616 178.929 77.5517 178.929C77.1466 178.922 76.749 179.032 76.359 179.259C75.9818 179.483 75.6602 179.826 75.3942 180.286C75.1282 180.747 74.9878 181.205 74.973 181.66C74.9664 182.119 75.0629 182.531 75.2627 182.894C75.4753 183.254 75.7554 183.534 76.1029 183.735C76.4586 183.94 76.8413 184.043 77.2511 184.042C77.661 184.042 78.0568 183.925 78.4387 183.693C78.8334 183.458 79.1637 183.109 79.4297 182.649ZM85.7787 180.689C85.5281 180.544 85.3669 180.338 85.2952 180.07C85.2234 179.802 85.2599 179.543 85.4046 179.293C85.5492 179.042 85.7554 178.881 86.0232 178.809C86.2909 178.737 86.5501 178.774 86.8007 178.918C87.0431 179.058 87.2003 179.262 87.272 179.53C87.3437 179.798 87.3073 180.057 87.1626 180.308C87.0179 180.558 86.8117 180.719 86.544 180.791C86.2763 180.863 86.0211 180.829 85.7787 180.689ZM85.9466 181.966L82.0896 188.646L80.7074 187.848L84.5644 181.168L85.9466 181.966ZM88.5835 184.781C88.9815 184.559 89.3999 184.45 89.8387 184.455C90.2902 184.457 90.7463 184.591 91.207 184.857L90.381 186.288L90.0294 186.085C89.4878 185.772 88.9963 185.672 88.5547 185.783C88.1212 185.899 87.7085 186.297 87.3165 186.976L85.2865 190.492L83.9043 189.694L87.7613 183.013L89.1435 183.811L88.5835 184.781ZM96.7033 192.411C96.5586 192.662 96.4118 192.879 96.2628 193.062L91.1584 190.115C90.8909 190.672 90.8416 191.215 91.0105 191.744C91.1795 192.272 91.5227 192.686 92.04 192.985C92.7836 193.414 93.4886 193.406 94.1551 192.961L95.6464 193.822C95.0897 194.32 94.4302 194.613 93.6681 194.701C92.9187 194.785 92.152 194.601 91.368 194.149C90.7294 193.78 90.2372 193.307 89.8913 192.73C89.5582 192.15 89.3954 191.517 89.4031 190.832C89.4235 190.143 89.6321 189.455 90.0288 188.768C90.4254 188.081 90.9105 187.558 91.484 187.2C92.0702 186.838 92.6956 186.66 93.3601 186.666C94.0326 186.677 94.6962 186.872 95.351 187.25C95.9814 187.614 96.4639 188.076 96.7982 188.635C97.1326 189.195 97.2926 189.804 97.2781 190.464C97.2682 191.116 97.0766 191.765 96.7033 192.411ZM95.5125 191.142C95.7984 190.628 95.8522 190.115 95.6739 189.602C95.4956 189.09 95.1437 188.682 94.6183 188.379C94.1415 188.103 93.6446 188.021 93.1278 188.132C92.6156 188.236 92.1779 188.527 91.8146 189.007L95.5125 191.142ZM97.5118 193.088C97.9084 192.401 98.3935 191.879 98.967 191.52C99.5532 191.158 100.175 190.978 100.831 190.979C101.487 190.981 102.135 191.166 102.773 191.535C103.582 192.002 104.136 192.581 104.438 193.272C104.752 193.96 104.797 194.713 104.572 195.532L103.081 194.671C103.151 194.269 103.106 193.899 102.947 193.559C102.787 193.219 102.505 192.932 102.101 192.699C101.536 192.372 100.966 192.313 100.393 192.521C99.8333 192.726 99.3456 193.188 98.9303 193.907C98.515 194.627 98.3563 195.284 98.4544 195.88C98.5606 196.48 98.8965 196.943 99.4623 197.27C100.263 197.732 100.995 197.686 101.66 197.132L103.151 197.993C102.565 198.56 101.889 198.892 101.122 198.988C100.36 199.076 99.5825 198.891 98.7903 198.434C98.1518 198.065 97.6677 197.597 97.3379 197.03C97.0129 196.454 96.8582 195.826 96.874 195.145C96.9025 194.461 97.1151 193.775 97.5118 193.088ZM108.129 196.276L105.994 199.974C105.849 200.225 105.801 200.439 105.849 200.618C105.909 200.793 106.081 200.962 106.364 201.125L107.213 201.615L106.548 202.767L105.456 202.137C104.834 201.778 104.441 201.357 104.278 200.875C104.114 200.392 104.222 199.824 104.6 199.169L106.735 195.471L105.947 195.016L106.598 193.888L107.386 194.343L108.345 192.682L109.739 193.487L108.78 195.148L110.405 196.086L109.754 197.214L108.129 196.276ZM112.893 196.343C112.642 196.198 112.481 195.992 112.409 195.724C112.337 195.457 112.374 195.197 112.519 194.947C112.663 194.696 112.869 194.535 113.137 194.463C113.405 194.392 113.664 194.428 113.915 194.573C114.157 194.713 114.314 194.917 114.386 195.184C114.458 195.452 114.421 195.711 114.277 195.962C114.132 196.212 113.926 196.374 113.658 196.445C113.39 196.517 113.135 196.483 112.893 196.343ZM113.061 197.62L109.204 204.301L107.821 203.502L111.678 196.822L113.061 197.62ZM113.853 207.13C113.223 206.766 112.734 206.296 112.389 205.719C112.047 205.134 111.881 204.499 111.888 203.814C111.901 203.12 112.105 202.43 112.502 201.743C112.894 201.064 113.391 200.548 113.993 200.195C114.596 199.843 115.237 199.674 115.918 199.69C116.599 199.706 117.258 199.898 117.897 200.267C118.535 200.635 119.031 201.11 119.385 201.692C119.739 202.273 119.914 202.913 119.91 203.611C119.906 204.309 119.708 204.998 119.316 205.677C118.924 206.356 118.422 206.869 117.812 207.217C117.201 207.565 116.545 207.731 115.844 207.714C115.155 207.694 114.492 207.499 113.853 207.13ZM114.546 205.93C114.902 206.135 115.282 206.242 115.687 206.249C116.1 206.262 116.502 206.154 116.892 205.927C117.282 205.699 117.617 205.343 117.897 204.858C118.177 204.373 118.32 203.911 118.325 203.472C118.335 203.026 118.236 202.629 118.027 202.281C117.817 201.934 117.535 201.658 117.179 201.453C116.824 201.248 116.443 201.141 116.038 201.133C115.641 201.131 115.256 201.248 114.882 201.484C114.513 201.713 114.188 202.07 113.908 202.555C113.493 203.274 113.353 203.937 113.488 204.543C113.636 205.146 113.988 205.608 114.546 205.93ZM126.041 204.968C126.566 205.272 126.972 205.652 127.258 206.108C127.552 206.569 127.693 207.081 127.68 207.645C127.667 208.208 127.486 208.793 127.136 209.4L124.861 213.34L123.491 212.549L125.647 208.815C125.992 208.217 126.106 207.674 125.989 207.186C125.877 206.69 125.562 206.292 125.044 205.994C124.527 205.695 124.022 205.619 123.528 205.765C123.047 205.907 122.633 206.278 122.288 206.876L120.132 210.61L118.75 209.812L122.607 203.132L123.989 203.93L123.548 204.693C123.933 204.549 124.344 204.501 124.78 204.548C125.224 204.6 125.644 204.74 126.041 204.968Z"
        fill="#555770"
      />
      <path
        d="M29.7419 173.992C29.3396 173.756 28.8219 173.89 28.5854 174.293C28.349 174.695 28.4834 175.213 28.8856 175.449L29.7419 173.992ZM132.116 235.848C132.567 235.731 132.838 235.269 132.721 234.818L130.811 227.458C130.694 227.007 130.233 226.736 129.781 226.853C129.329 226.97 129.058 227.431 129.176 227.883L130.873 234.425L124.332 236.123C123.88 236.24 123.609 236.701 123.726 237.152C123.843 237.604 124.305 237.875 124.756 237.758L132.116 235.848ZM28.8856 175.449L131.475 235.758L132.332 234.302L29.7419 173.992L28.8856 175.449Z"
        fill="#A9C1F3"
      />
      <defs>
        <filter
          id="filter0_i_3346_198656"
          x="272.996"
          y="143.279"
          width="376.134"
          height="44.8066"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5.13964" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_198656" />
        </filter>
        <filter
          id="filter1_i_3346_198656"
          x="23.8196"
          y="27.6465"
          width="225.356"
          height="130.109"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.92072" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_198656" />
        </filter>
        <filter
          id="filter2_i_3346_198656"
          x="23.8196"
          y="27.6465"
          width="225.356"
          height="130.109"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.92072" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_198656" />
        </filter>
        <filter
          id="filter3_i_3346_198656"
          x="45.3391"
          y="27.6445"
          width="193.599"
          height="132.678"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.92072" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3346_198656" />
        </filter>
        <linearGradient
          id="paint0_linear_3346_198656"
          x1="461.063"
          y1="166.247"
          x2="461.063"
          y2="190.609"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B3CBFF" />
          <stop offset="1" stop-color="#6790E5" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_3346_198656"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(147.912 85.1637) rotate(145.114) scale(134.929 273.492)"
        >
          <stop stop-color="#B3CBFF" />
          <stop offset="1" stop-color="#6790E5" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3346_198656"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(147.912 85.1637) rotate(145.114) scale(134.929 273.492)"
        >
          <stop stop-color="#B3CBFF" />
          <stop offset="1" stop-color="#6790E5" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3346_198656"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(153.274 90.728) rotate(157.223) scale(80.3477 162.859)"
        >
          <stop stop-color="#B3CBFF" />
          <stop offset="1" stop-color="#6790E5" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_3346_198656"
          x1="61.4977"
          y1="22.795"
          x2="109.111"
          y2="64.5385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C7DFF9" stop-opacity="0.85" />
          <stop offset="1" stop-color="#DAF1FB" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3346_198656"
          x1="183.506"
          y1="163.082"
          x2="162.796"
          y2="124.839"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3346_198656"
          x1="183.506"
          y1="163.085"
          x2="162.796"
          y2="124.842"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
